module.exports = __webpack_public_path__ + "img/youtube-icon-bg.eefbea71ab02b980c4e74cb3d6e43765.svg";